import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useApi, useFetch } from '@hooks';
import { useSaveServiceResponse } from '@store';
import {
	AccountDeleteCookiesInputDto,
	AccountDeleteCookiesOutputDto,
	AccountDeleteCookiesOutputDtoSingleOutputMessage,
} from '@types';

export const useFetchAccountDeleteCookies = (): UseFetchHookOutput<
	AccountDeleteCookiesInputDto,
	AccountDeleteCookiesOutputDto
> => {
	const { accountDeleteCookies: fetchAccountDeleteCookies } = useApi();
	const saveServiceResponse = useSaveServiceResponse();

	return useFetch<AccountDeleteCookiesInputDto, AccountDeleteCookiesOutputDto>({
		input: {
			fetchFn: fetchAccountDeleteCookies,
			onSuccess: (res: AccountDeleteCookiesOutputDtoSingleOutputMessage) => {
				saveServiceResponse({ accountDeleteCookies: res.data || {} });
			},
		},
		showGenericErrorModal: false,
		showGlobalLoader: false,
		requestName: 'account/deleteCookies',
	});
};
